<div class="tab-body mat-elevation-z1">
  <div class="section-header">
    <h2>
      <mat-icon>cloud</mat-icon>
      Manage Environments
    </h2>
  </div>

  <div class="env-filter-row">
    <mat-form-field appearance="outline">
      <mat-label>Filter By</mat-label>
      <mat-select [(ngModel)]="environmentsFilterField" (selectionChange)="onEnvironmentsFilterFieldChange()">
        <mat-option *ngFor="let option of environmentFilterOptions" [value]="option.value">
          {{ option.label }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Value</mat-label>
      <ng-container *ngIf="usesSelectableEnvironmentFilter(); else textEnvironmentFilter">
        <mat-select
          [(ngModel)]="environmentsFilterValue"
          (selectionChange)="onEnvironmentsFilterValueChange()">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let option of environmentFilterValueOptions" [value]="option.value">
            {{ option.label }}
          </mat-option>
        </mat-select>
      </ng-container>
      <ng-template #textEnvironmentFilter>
        <input
          matInput
          [(ngModel)]="environmentsFilterValue"
          [placeholder]="getEnvironmentFilterPlaceholder()"
          (input)="onEnvironmentsFilterValueChange()"
          (keyup.enter)="applyEnvironmentsFilterImmediately()" />
      </ng-template>
    </mat-form-field>

    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="clearEnvironmentsFilter()"
      [disabled]="!environmentsFilterValue && environmentsFilterField === 'name'">
      Clear
    </button>
  </div>

  <div class="loading-overlay" *ngIf="loading">
    <mat-spinner></mat-spinner>
  </div>

  <table class="admin-table" *ngIf="getDisplayedEnvironments().length > 0 && !loading">
    <thead>
      <tr>
        <th>Environment</th>
        <th>Owner</th>
        <th>Status</th>
        <th>Region</th>
        <th>Age</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let env of getDisplayedEnvironments(); trackBy: trackByEnvName"
        class="env-row"
        (click)="viewEnvironment(env)"
        (keydown.enter)="viewEnvironment(env)"
        (keydown.space)="viewEnvironment(env); $event.preventDefault()"
        role="button"
        tabindex="0">
        <td><code>{{ env.name }}</code></td>
        <td>{{ env.owner }}</td>
        <td>
          <span class="env-status-badge" [ngClass]="'env-status-' + env.state.toLowerCase()">
            {{ env.state }}
          </span>
        </td>
        <td>{{ env.region }}</td>
        <td>{{ getEnvironmentAge(env.createDate) }}</td>
        <td class="env-actions" (click)="$event.stopPropagation()">
          <button mat-icon-button color="primary" type="button" matTooltip="Resume"
            (click)="restartEnvironment(env)"
            [disabled]="!canRestart(env) || isActionBusy(envRestartActionKey(env.name)) || isActionBusy(envStopActionKey(env.name)) || isActionBusy(envDeleteActionKey(env.name))">
            <mat-spinner *ngIf="isActionBusy(envRestartActionKey(env.name))" diameter="14" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isActionBusy(envRestartActionKey(env.name))">play_arrow</mat-icon>
          </button>
          <button mat-icon-button color="accent" type="button" matTooltip="Stop"
            (click)="stopEnvironment(env)"
            [disabled]="!canStop(env) || isActionBusy(envRestartActionKey(env.name)) || isActionBusy(envStopActionKey(env.name)) || isActionBusy(envDeleteActionKey(env.name))">
            <mat-spinner *ngIf="isActionBusy(envStopActionKey(env.name))" diameter="14" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isActionBusy(envStopActionKey(env.name))">pause_circle</mat-icon>
          </button>
          <button mat-icon-button type="button" class="env-delete-btn" matTooltip="Delete"
            (click)="confirmDeleteEnvironment(env)"
            [disabled]="isActionBusy(envDeleteActionKey(env.name))">
            <mat-spinner *ngIf="isActionBusy(envDeleteActionKey(env.name))" diameter="14" class="btn-spinner"></mat-spinner>
            <mat-icon *ngIf="!isActionBusy(envDeleteActionKey(env.name))">delete_forever</mat-icon>
          </button>
        </td>
      </tr>
    </tbody>
  </table>

  <div class="empty-state" *ngIf="getDisplayedEnvironments().length === 0 && !loading">
    <mat-icon>cloud_off</mat-icon>
    <p>No environments found.</p>
  </div>

  <div class="pagination-row" *ngIf="environmentsTotalItems > 0 && !loading">
    <button mat-stroked-button type="button" (click)="refreshEnvironments()">
      <mat-icon>refresh</mat-icon>
      Refresh
    </button>
    <button mat-stroked-button type="button" (click)="goToPreviousEnvironmentsPage()" [disabled]="environmentsPage === 1">Previous</button>
    <span>Page {{ environmentsPage }} of {{ environmentsTotalPages }}</span>
    <button mat-stroked-button type="button" (click)="goToNextEnvironmentsPage()" [disabled]="environmentsPage >= environmentsTotalPages">Next</button>
  </div>
</div>

